module.exports = __webpack_public_path__ + "img/ia-01-5.924ef419.jpg";